import React from "react";
import { Link, Navigate, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, SpanStyled } from "../styled/Elements";
import { NavDataConfig } from "../data/data";
import { AuthfooterWrapper } from "./styled";

const AuthFooter = () => {
    const { t } = useTranslation();
    const date_year = new Date();
    return (
        <AuthfooterWrapper>
            <Box className="nav-bar-list-footer">
                <ul>
                    {NavDataConfig.map((item, key) => (
                        <li key={key}>
                            <Link to={`/${item.to}`} >{t(item.label)}</Link>
                        </li>
                    ))}
                    
                </ul>
            </Box>
            <Box className='copyRight'>
                <SpanStyled size='15px' className='copyRightText'>
                    &copy; {date_year.getFullYear()} {t('Falhub')}. {t("Allrightsreserved")}.
                </SpanStyled>
                
            </Box>
        </AuthfooterWrapper>
    );
}

export default AuthFooter;